// Thème Zenith + MoonBundle : fix unique drawer + scroll lock
(function () {
  var drawerId = 'moonbundle-cart-drawer';
  var userInitiatedUntil = 0;

  // 1. Détecte les clics volontaires sur les triggers panier
  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var trigger = target.closest(
      '[data-moonbundle-cart-toggle], .moonbundle-cart-toggle, .header__cart, .cart-icon-bubble, #cart-icon-bubble, .cart-icon, .site-header__cart, a[href="/cart"], a[href$="/cart"], [data-cart-trigger], [aria-controls*="cart"], summary[aria-controls*="cart"]'
    );
    if (trigger && !trigger.closest('form[action*="/cart/add"]')) {
      userInitiatedUntil = Date.now() + 30000; // 30s d'ouverture autorisée
    }
  }, true);

  // 2. Ferme le drawer MoonBundle s'il s'ouvre sans clic volontaire
  // 2. Ferme le drawer MoonBundle dès qu'il s'ouvre sans clic volontaire (réaction instantanée)
  function maybeCloseDrawer(d) {
    if (!d) return;
    var isOpen = d.getAttribute('data-open') === 'true' || d.classList.contains('open');
    if (!isOpen || Date.now() <= userInitiatedUntil) return;
    try {
      d.setAttribute('data-open', 'false');
      d.classList.remove('open');
      d.classList.remove('moonbundle-cart-drawer-open');
      document.body.classList.remove('moonbundle-cart-drawer-opened');
      document.body.classList.remove('no-scroll');
      document.documentElement.classList.remove('moonbundle-cart-drawer-open');
      var ov = document.getElementById('moonbundle-cart-drawer-overlay');
      if (ov) ov.classList.remove('open');
    } catch (err) {}
  }
  function watchDrawer() {
    var d = document.getElementById(drawerId);
    if (!d) { setTimeout(watchDrawer, 200); return; }
    // Observer SEULEMENT le drawer lui-même (pas subtree), et seulement data-open + class
    var observer = new MutationObserver(function () {
      maybeCloseDrawer(d);
    });
    observer.observe(d, { attributes: true, attributeFilter: ['data-open', 'class'] });
    // Check initial au cas où le drawer serait déjà ouvert au chargement
    maybeCloseDrawer(d);
  }
  watchDrawer();
  // Filet de sécurité (intervalle lent à 300ms, léger)
  setInterval(function () {
    maybeCloseDrawer(document.getElementById(drawerId));
  }, 300);

  // 3. Débloque le scroll quand aucun drawer n'est visible
  function isAnyDrawerVisible() {
    var moon = document.getElementById(drawerId);
    if (moon && (moon.getAttribute('data-open') === 'true' || moon.classList.contains('open'))) return true;
    var native = document.getElementById('CartDrawer');
    if (native) {
      var cs = getComputedStyle(native);
      if (cs.visibility === 'visible' && parseFloat(cs.opacity) > 0.5) return true;
    }
    return false;
  }
  function unlock() {
    if (isAnyDrawerVisible()) return;
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('touch-action');
    document.body.style.removeProperty('height');
    document.body.classList.remove('overflow-hidden-drawer');
    document.body.classList.remove('overflow-hidden');
    var native = document.getElementById('CartDrawer');
    if (native && getComputedStyle(native).visibility !== 'visible') {
      native.classList.remove('modal--open', 'active', 'is-open');
    }
  }
  function multiUnlock() {
    setTimeout(unlock, 150);
    setTimeout(unlock, 600);
    setTimeout(unlock, 1500);
  }
  document.addEventListener('click', multiUnlock);
  document.addEventListener('touchend', multiUnlock);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') multiUnlock(); });

  // Intercepte les requêtes panier pour nettoyer après
  var originalFetch = window.fetch;
  window.fetch = function () {
    var url = (arguments[0] && arguments[0].url) || arguments[0] || '';
    var p = originalFetch.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/(change|update|clear|add)/.test(url)) {
      p.finally(multiUnlock);
    }
    return p;
  };
})();